




























































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Company as ICompany } from "@/api/models/company";
import { Disk as IDisk } from "@/api-v2/files/models";
import { DiskList as IDiskList } from "@/api-v2/files/models";
import Doughnut from "@/components/companies/Doughnut.vue";
import { isRoot } from "@/plugins/roles";
import { FileDiskSpaceUpdate as IFileDiskSpaceUpdate } from "@/api/models/file-disk-space-update";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import FileManager from "@/components/files/FileManager.vue";
import { fileApi } from "@/getinfo-api";
import CFileManager from "@/components/fileManager/CFileManager.vue";

@Component({
  components: { CFileManager, Doughnut, FileManager }
})
export default class CompanyFileSizeLimit extends Vue {
  @Prop() companyInfo!: ICompany;
  companyDisk!: any;
  fileDiskSpace!: IDisk;
  changeDiskSpace: number | undefined;
  rerender: boolean = true;
  showFileManager: boolean = false;

  data() {
    return {
      companyDisk: undefined,
      fileDiskSpace: undefined,
      changeDiskSpace: undefined
    };
  }

  submitDiskSpace() {
    if (this.changeDiskSpace && this.companyInfo?.id) {
      let param: IFileDiskSpaceUpdate = {
        size: this.changeDiskSpace
      };
      api.CompanyFileApi.companyUpdateDisk(this.companyInfo.id, param)
        .then(() => {
          this.getFileSpace();
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  getFileSpace() {
    if (this.companyInfo) {
      fileApi.DiskApi.my(0, 100).then((res: { data: IDiskList }) => {
        this.companyDisk = res.data.items.find(
          (el: IDisk) => el.id === this.companyInfo.diskId
        );
      });
    }
  }
  @Watch("companyInfo")
  checkCompanyInfo() {
    this.getFileSpace();
  }

  getFileSizeFormatter(bytes: number, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  mounted() {
    this.getFileSpace();
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get root() {
    return isRoot();
  }
}
